module.exports = __webpack_public_path__ + "static/media/color1.a9bb4c08.jpg";